import { Navigate } from "react-router-dom";

import { AdminLoginForm } from "@/components/admin/AdminLoginForm";
import { useAdminAuth } from "@/lib/auth/admin-auth-context";

/**
 * Équivalent de apps/web/app/(admin)/admin/connexion/page.tsx. Seule route
 * admin exclue d'`AdminRouteGuard` (cf. router.tsx). Porté avec le même
 * comportement : déjà connecté → redirection immédiate vers `/admin` (ici via
 * `<Navigate>` plutôt que `redirect()` côté serveur, puisqu'il n'y a plus de
 * session lisible avant le premier rendu client).
 */
export function AdminConnexionPage() {
  const { isLoggedIn } = useAdminAuth();

  if (isLoggedIn) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-cream px-4 py-12">
      <AdminLoginForm />
    </div>
  );
}
